import {
  AggregatedFundCommissionStatistics,
  buildAccountsApi,
} from "@rentablo/api/apiv1";
import { useAuthQuery, UseQueryExtendedOptions } from "@rentablo/api";
import { GET_FUND_COMMISITIONS_KEY } from "@api/cacheKeys";

export const useFundCommissions = (
  options: UseQueryExtendedOptions<
    AggregatedFundCommissionStatistics,
    AxiosApiError,
    AggregatedFundCommissionStatistics
  > = { enabled: true }
) => {
  return useAuthQuery(
    [GET_FUND_COMMISITIONS_KEY],
    ({ token }) => {
      const api = buildAccountsApi(token);
      return api
        .fundCommissions(undefined, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(({ data }) => data);
    },
    options
  );
};
